import axios, { AxiosError } from "axios";
import { networkSchema } from "./Network.service.schemas";

const API = import.meta.env.VITE_API;

export default {
	deviceId: null,

	setDeviceId(deviceId) {
		this.deviceId = deviceId;
	},

	/**
	 *
	 * @param {string} revision
	 * @param {string | null} deviceId
	 */
	async getAllFromRevision(revision = "current", deviceId = null) {
		try {
			const response = await axios.get(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/${revision}/networks`
			);
			return networkSchema.array().parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	},

	/**
	 *
	 * @param {string} revision
	 * @param {string | null} protocol
	 * @param {string | null} deviceId
	 */
	async getAllFromRevisionAndProtocol(
		revision = "current",
		protocol = null,
		deviceId = null
	) {
		if (protocol === null) {
			throw "You must provide a protocol";
		}

		try {
			const response = await axios.get(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/${revision}/networks?protocol=${protocol}`
			);
			return networkSchema.array().parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	},

	/**
	 *
	 * @param {string | null} networkId
	 * @param {string} revision
	 * @param {string | null} deviceId
	 */
	async getFromRevision(
		networkId = null,
		revision = "current",
		deviceId = null
	) {
		if (networkId === null) {
			throw "You must provide a Network Id";
		}

		try {
			const response = await axios.get(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/${revision}/networks/${networkId}`
			);
			return networkSchema.parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	},

	/**
	 *
	 * @param {string | null} equipmentId
	 * @param {string} revision
	 * @param {string | null} deviceId
	 */
	async getNetworkEquipmentBelongsToFromRevision(
		equipmentId = null,
		revision = "current",
		deviceId = null
	) {
		if (equipmentId === null) {
			throw "You must provide an Equipment Id";
		}

		try {
			const response = await axios.get(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/${revision}/networks`,
				{
					params: {
						equipmentId: equipmentId
					}
				}
			);
			return networkSchema.array().parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	},

	/**
	 *
	 * @param {import('./Network.service.schemas').InputNetwork} params
	 * @param {string | null} deviceId
	 */
	async create(params, deviceId = null) {
		try {
			const response = await axios.post(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/draft/networks`,
				params
			);
			return networkSchema.parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	},

	/**
	 *
	 * @param {import('./Network.service.schemas').InputNetwork} params
	 * @param {string | null} deviceId
	 */
	async validate(params, deviceId = null) {
		try {
			const response = await axios.post(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/draft/networks?validateOnly=true`,
				params
			);
			return networkSchema.parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	},

	/**
	 *
	 * @param {string} networkId
	 * @param {import('./Network.service.schemas').InputNetwork} params
	 * @param {string | null} deviceId
	 * @returns
	 */
	async update(networkId, params, deviceId = null) {
		try {
			const response = await axios.put(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/draft/networks/${networkId}`,
				params
			);
			return networkSchema.parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	},

	/**
	 *
	 * @param {string} networkId
	 * @param {import('./Network.service.schemas').InputNetwork} params
	 * @param {string | null} deviceId
	 */
	async validateUpdating(networkId, params, deviceId = null) {
		try {
			const response = await axios.put(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/draft/networks/${networkId}?validateOnly=true`,
				params
			);
			return networkSchema.parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	},

	/**
	 *
	 * @param {string} networkId
	 * @param {string | null} deviceId
	 */
	async delete(networkId, deviceId = null) {
		try {
			const response = await axios.delete(
				`${API}/devices/${
					deviceId || this.deviceId
				}/configs/draft/networks/${networkId}`
			);
			return networkSchema.parse(response.data);
		} catch (error) {
			if (error instanceof AxiosError) {
				throw error.response;
			}
			throw error;
		}
	}
};
